import { observer } from "mobx-react";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Button, Form, Grid, Header, Icon, Table, Select } from "semantic-ui-react";
import { AlertMessage, DateInput, Text } from "../../../components/common";
import { CurrencyInput } from "../../../components/common/input";
import { NoPermissionMessage } from "../../../components/permission";
import { currency } from "../../../utils/format-helper";
import { hasPermission } from "../../../utils/render-by-permission";
import { IDebtCollectionSueModel } from "../DebtCollectionModel";

interface IDebtCollectionSueCalculator extends WithTranslation {
  debtSue: IDebtCollectionSueModel;
}

@observer
class DebtCollectionSueCalculator extends React.Component<
  IDebtCollectionSueCalculator
> {
  state = {
    listData: [],
    total: {
      judgementBalance: 0,
      lawyerFee: 0,
      fee: 0,
      otherExpense: 0,
      Interest: 0,
      sumAll: 0
    }
  }
  public render() {
    const { t, debtSue } = this.props;
    return (
      <Form>
        <Header
          size="medium"
          content={
            t(
              "คำนวนจำนวนงวด"
            )
          }
          subheader={
            t(
              ""
            )
          } />

        <Form.Field
          id="form-select-interval"
          control={Select}
          label={t("ระบุจำนวนงวด")}
          options={this.getOptions(12)}
          onChange={this.renderResult}
        />

        {this.renderTable()}
      </Form>
    );
  }

  public renderTable() {
    return (
      <React.Fragment>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>จำนวนงวด</Table.HeaderCell>
              <Table.HeaderCell>วันที่ชำระ</Table.HeaderCell>
              <Table.HeaderCell>เงินต้น</Table.HeaderCell>
              <Table.HeaderCell>ดอกเบี้ย</Table.HeaderCell>
              <Table.HeaderCell>ค่าทนาย</Table.HeaderCell>
              <Table.HeaderCell>ค่าฤชาธรรมเนียม</Table.HeaderCell>
              <Table.HeaderCell>ค่าใช้จ่ายอื่นๆ</Table.HeaderCell>
              <Table.HeaderCell>รวม</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.state.listData.map((dat: any, i) => {
              return (
                <Table.Row>
                  <Table.Cell>{dat.record_no}</Table.Cell>
                  <Table.Cell>{dat.paidDate}</Table.Cell>
                  <Table.Cell>{currency(dat.judgementBalance, 2)}</Table.Cell>
                  <Table.Cell>{currency(dat.Interest, 2)}</Table.Cell>
                  <Table.Cell>{currency(dat.lawyerFee, 2)}</Table.Cell>
                  <Table.Cell>{currency(dat.fee, 2)}</Table.Cell>
                  <Table.Cell>{currency(dat.otherExpense, 2)}</Table.Cell>
                  <Table.Cell>{currency(dat.judgementBalance + dat.Interest + dat.lawyerFee + dat.fee + dat.otherExpense, 2)}</Table.Cell>
                </Table.Row>
              )
            })}
            <Table.Row>
              <Table.Cell colSpan="2">รวม</Table.Cell>
              <Table.Cell>{currency(this.state.total.judgementBalance, 2)}</Table.Cell>
              <Table.Cell>{currency(this.state.total.Interest, 2)}</Table.Cell>
              <Table.Cell>{currency(this.state.total.lawyerFee, 2)}</Table.Cell>
              <Table.Cell>{currency(this.state.total.fee, 2)}</Table.Cell>
              <Table.Cell>{currency(this.state.total.otherExpense, 2)}</Table.Cell>
              <Table.Cell>{currency(this.state.total.sumAll, 2)}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </React.Fragment>
    )
  }

  public getOptions = (val: number) => {
    let ret = [];
    for (let i = 1; i <= val; i++) {
      let d = { key: i, value: i, text: i };
      ret.push(d);
    }
    return ret;
  }

  public renderResult = (e: any, data: any) => {
    const { t, debtSue } = this.props;
    //let totalAmount = debtSue.judgementBalance +     
    const submitDate = new Date(debtSue.submitDate);
    const lastDate = new Date(debtSue.submitDate);
    let curDate = new Date(debtSue.submitDate);
    //console.log(debtSue);

    if (submitDate.getDay() > 5) {
      lastDate.setMonth(lastDate.getMonth() + data.value + 1);
      curDate = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 5);
    } else {
      lastDate.setMonth(lastDate.getMonth() + data.value);
      curDate = new Date(curDate.getFullYear(), curDate.getMonth(), 5);
    }

    let finalDate = new Date(lastDate.getFullYear() + "-" + lastDate.getMonth().toString().padStart(2, '0') + '-05');
    let dateDiff = (finalDate.getTime() - submitDate.getTime()) / (1000 * 3600 * 24);
    let totalInterest = 0
    if (debtSue.judgementInterestRate > 0) {
      totalInterest = debtSue.judgementBalance * (debtSue.judgementInterestRate / 100) * (dateDiff / 365.25);
    }

    let records = [];
    let i: number;
    let noCount = data.value;
    //let totalAll = debtSue.judgementBalance + debtSue.fee + debtSue.lawyerFee + totalInterest + debtSue.otherExpense + 0;
    let sumAll: number = 0;

    sumAll = Number(debtSue.judgementBalance) + Number(debtSue.fee) + Number(debtSue.lawyerFee) + Number(debtSue.otherExpense) + totalInterest;
    for (i = 1; i <= data.value; i++) {
      let data = {
        record_no: i,
        paidDate: curDate.toLocaleDateString("th-TH", { year: 'numeric', month: 'long', day: 'numeric' }),
        judgementBalance: debtSue.judgementBalance / noCount,
        lawyerFee: debtSue.lawyerFee / noCount,
        fee: debtSue.fee / noCount,
        otherExpense: debtSue.otherExpense / noCount,
        Interest: totalInterest / noCount,
        sumAll: sumAll / noCount
      }
      curDate = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 5);
      records.push(data);
    }
    let total = {
      judgementBalance: debtSue.judgementBalance,
      lawyerFee: debtSue.lawyerFee,
      fee: debtSue.fee,
      otherExpense: debtSue.otherExpense,
      Interest: totalInterest,
      sumAll: sumAll
    }

    //this.setState({ listData: records })
    this.setState({ listData: records });
    this.setState({ total: total });
  }

  public toNextMonth(d: Date) {
    if (d.getDay() > 5) {

    } else {
      d.setMonth(d.getMonth() + 2);
    }
    let mon = new Date(d.getFullYear() + "-" + d.getMonth().toString().padStart(2, '0') + '-05');
    return mon;
  }
}

export default withTranslation()(DebtCollectionSueCalculator);